import { isEqual } from 'lodash';
import CryptoJS from 'crypto-js';
import JSZip from '@turbowarp/jszip';

export const NORMAL_ZIP_PREFIX = new Uint8Array([80, 75, 3, 4, 10, 0, 0, 0]);
export const CHAOS_ZIP_PREFIX = new Uint8Array([55, 122, 188, 175, 9, 5, 2, 7]);
export const SECRET_KEY_PREFIX = 'KzdnFCBRvq3';
export const XIGUA_ENCODE_HEADER = '{';
export const PROJECT_JSON = 'Project.json';

const concatTypedArray = (resultConstructor, ...arrays) => {
    const totalLength = arrays.reduce((sum, arr) => sum + arr.length, 0);
    const result = new resultConstructor(totalLength);
    let offset = 0;
    for (const arr of arrays) {
        result.set(arr, offset);
        offset += arr.length;
    }
    return result;
};

const parseProjectIdBySB3Url = (maybeProjectUrl) => {
    if (/^https?:\/\//.test(maybeProjectUrl) && /\.sb3$/.test(maybeProjectUrl)) {
        const fileName = maybeProjectUrl.split('/').pop();
        const [projectId] = fileName.split('.');
        return projectId;
    }
    return maybeProjectUrl;
};

const AES_CBC_DECRYPT = (textBase64, secretKey) => {
    const keyHex = CryptoJS.enc.Base64.parse(`${SECRET_KEY_PREFIX}${secretKey}`);
    const ivHex = keyHex.clone();
    ivHex.sigBytes = 16;
    ivHex.words.splice(4);
    const decrypt = CryptoJS.AES.decrypt(textBase64, keyHex, {
        iv: ivHex,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return CryptoJS.enc.Utf8.stringify(decrypt);
};

const decodeString = (e) => {
    const t = e.length - 1;
    const n = String(t).substr(-1);
    const r = e.charAt(t);
    return `${e.substr(0, +n)}${r}${e.substring(+n + 1, t)}`;
};

/**
 * 解密项目数据
 * @param {ArrayBuffer} projectData - 待解密的原始数据
 * @param {string} projectUrl - 项目URL
 * @returns {Promise<ArrayBuffer>}
*/
export const decryptProjectData = async (projectData, projectUrl) => {
   const uniqueId = parseProjectIdBySB3Url(projectUrl);

   const dataArray = new Uint8Array(projectData);
   let processedData = dataArray;

   const prefix = dataArray.slice(0, 8);
   const isChaos = isEqual(Array.from(prefix), Array.from(CHAOS_ZIP_PREFIX));
   const isNormal = isEqual(Array.from(prefix), Array.from(NORMAL_ZIP_PREFIX));

   if (isChaos) {
       processedData = concatTypedArray(Uint8Array, NORMAL_ZIP_PREFIX, dataArray.slice(8));
   } else if (!isNormal) {
       const decryptedText = AES_CBC_DECRYPT(
           new TextDecoder('utf-8').decode(dataArray),
           uniqueId
       );
       processedData = new Uint8Array(decryptedText.split(',').map(Number));
   }

   try {
       const zip = await JSZip.loadAsync(processedData);
       const jsonFileName = Object.keys(zip.files).find(
           name => name.toLowerCase() === PROJECT_JSON.toLowerCase()
       );
       if (jsonFileName) {
           const jsonStr = await zip.file(jsonFileName).async('text');
           if (!jsonStr.startsWith(XIGUA_ENCODE_HEADER)) {
               const decodedStr = decodeURIComponent(atob(decodeString(jsonStr)));
               zip.file(jsonFileName, decodedStr);
               processedData = await zip.generateAsync({ type: 'uint8array' });
           }
       }
   } catch (error) {
       console.warn('ZIP处理失败（非标准ZIP）:', error);
   }

   return processedData.buffer;
};